export default __webpack_public_path__ + "static/media/pg.2017eb70.svg";